import * as schemas from "./schemas";
import { CLIENT_TOKEN } from "shadow-client";
import { HydraClient } from "shadow-client/axios/";
import generator from "shadow-client/endpoints/generator";

// contacts
const contactGenerator = generator.with(`/${CLIENT_TOKEN}/contacts`, schemas.contact);
export const fetchContactList = contactGenerator.fetchEntityList;
export const fetchContact = contactGenerator.fetchEntity;

// temporary contacts
const tempContactGenerator = generator.with(`/${CLIENT_TOKEN}/temp_contacts`, schemas.contact);
export const saveTempContact = tempContactGenerator.saveEntity;

// find contact
const findContactHydraClient = new HydraClient(`/${CLIENT_TOKEN}/find_contacts`);
export const fetchFindContactList = (...args) => dispatch => {
  const sendRequest = findContactHydraClient.fetchEntityList(...args);

  return sendRequest;
};



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/contactApi/index.js